module.exports = __webpack_public_path__ + "static/speed-hero-6939ddcf423c870c55855df8505675b5.png";